








































































































































































































































































































import RouteTab from '@/components/RouteTab.vue';
import { Component, Vue } from 'vue-property-decorator';
import secondaryNav from '@/components/navbars/secondary-nav.vue';
import ErrorDiv from '@/components/display/errorDiv.vue';
import { Gateway, Node, Product, ProductStatus, Sensor, Transceiver, User } from '@/api';
import SimPro from '@/components/tables/simPro.vue';
import Toast from '@/components/display/toast.vue';
import TitleMixin from '@/mixins/title-mixin';
import RouterLinkButton from '@/components/elements/buttons/router-link-button.vue';
import infoTabs from '@/layouts/parent/BTabsParent.vue';
import TreeView from '@/components/display/tree.vue';
import EntityMap from '@/components/display/maps/entityMap.vue';
import * as Vue2Leaflet from 'vue2-leaflet';
import InformationRow from '@/components/display/information-row.vue';
import SiteAddressSearch from '@/pages/account/sites/components/SiteAddressSearch.vue';
import { SiteService } from '@/services/site-service';
import { AddressExtended, ProductExtended, SiteExtended, UserExtended } from '@/models/extensions';
import { ParsingUtil } from '@/common/ParsingUtil';
import ChangelogLink from '@/components/display/changelog-link.vue';
import { StatusUtil } from '@/util/status-util';

@Component({
	components: {
		RouteTab,
		ChangelogLink,
		SiteAddressSearch,
		RouterLinkButton,
		ErrorDiv,
		secondaryNav,
		SimPro,
		infoTabs,
		InformationRow,
		TreeView,
		EntityMap,
	},
	mixins: [TitleMixin],
})
export default class SiteView extends Vue {
	public showMap = true;
	public smallScreen = window.innerWidth < 1000;
	public site: any | null = null;
	public products: Product[] = [];
	public transceivers: Transceiver[] = [];
	public nodes: Node[] = [];
	public gateways: Gateway[] = [];
	public sensors: Sensor[] = [];
	public address: AddressExtended = {};
	public markers: any[] = [];
	public users: any[] = [];
	public audits: any[] = [];
	public siteError: string | null = null;
	public loading = true;
	private refreshKey: number = 0;

	public productFields: Array<{ key: string; label: string }> | null = [
		{ key: 'id', label: 'Id' },
		{ key: 'type', label: 'Type' },
		{ key: 'supplierNumber', label: 'Supplier Number' },
		{ key: 'status', label: 'Status' },
		{ key: 'volume', label: 'Volume' },
		{ key: 'temperature', label: 'Temp' },
		{ key: 'org.name', label: 'Organisation' },
	];

	public auditFields: Array<{ key: string; label: string }> | null = [
		{ key: 'created_at', label: 'Date Updated' },
		{ key: 'from', label: 'From' },
		{ key: 'to', label: 'To' },
		{ key: 'user.name', label: 'By' },
	];

	private simProUrl: string = process.env.VUE_APP_SIMPRO_BASE_URL + '/staff/location.php';

	private siteService: SiteService = new SiteService();

	private siteId?: number | null;

	/**
	 * Mixin to set the page title
	 */
	public pageTitle() {
		return this.site ? `Site | ` + this.site.name : 'Site Not Found';
	}

	public async deleteSite() {
		if (
			this.products.filter(
				product =>
					product.status !== ProductStatus.Removed && product.status !== ProductStatus.Cancelled,
			).length > 0
		) {
			confirm(
				'You will need to remove products ' +
					this.products.map(product => '\n' + product.name + ' : ' + product.status) +
					'\nbefore deleting site',
			);
			return;
		}
		if (this.site?.id && confirm('Are you sure you wish to delete site: ' + this.site.name)) {
			const deleteResponse = await this.siteService.deleteSite(this.site.id);
			if (deleteResponse.errorMessage) {
				new Toast().makeToast(deleteResponse.errorMessage, 'Error Deleting Site', 'danger', true);
				return;
			}
			new Toast().makeToast(
				'You have deleted Site ' + this.site.name,
				'Success Deleting Site ' + this.site.id,
				'success',
				true,
			);

			await this.$router.push({
				name: `sites.list`,
			} as any);
		}
	}

	public async load() {
		this.siteId = ParsingUtil.parseId(this.$route.params.siteId);
		if (this.siteId == null) {
			this.loading = false;
			this.siteError = `Failed to load site for ID '${this.$route.params.siteId}'`;
			return;
		}

		this.loading = true;

		const { site, errorMessage } = await this.siteService.getSiteById<
			SiteExtended<AddressExtended>
		>(
			this.siteId,
			'sensors,' +
				'address,' +
				'transceivers,' +
				'sensors.vat,' +
				'products,' +
				'org,' +
				'products.users,' +
				'products.org,' +
				'audits,' +
				'audits.user,' +
				'transceivers.gateway.entitylocation,' +
				'transceivers.nodes.entitylocation,' +
				'transceivers.nodes.sensors,' +
				'transceivers.sensors,' +
				'transceivers.entitylocation,' +
				'nodes,' +
				'gateways',
		);
		if (!site || errorMessage) {
			this.site = null;
			this.siteError = errorMessage ?? 'Unknown error, no site found';
			this.loading = false;
			return;
		}

		const products: ProductExtended[] = site.products || [];

		const users: any[] = [];
		products
			.map(p => p.users)
			.flat()
			.forEach(u => {
				if (!users.some(u2 => u2.id === u?.id)) users.push(u);
			});
		users.forEach(u => {
			u.products = products.filter(p => p?.users?.find(u2 => u2.id === u.id));
		});

		this.users = users; // make distinct
		this.site = site;
		this.products =
			products
				?.sort((a, b) => (a?.id ?? 0) - (b?.id ?? 0))
				?.sort((a, b) => StatusUtil.getPriority(a.status) - StatusUtil.getPriority(b.status)) ?? [];

		const { transceivers, sensors, address, audits } = site;

		this.transceivers = transceivers || [];
		this.sensors = sensors || [];
		this.address = address || {};
		this.audits = audits || [];

		this.markers.push({
			position: {
				lat: parseFloat(this.site.latitude),
				lng: parseFloat(this.site.longitude),
			},
		});

		this.gateways = (site.gateways ?? []).map(gateway => {
			if (gateway.transceiverId == null) {
				return {
					_cellVariants: { transceiverId: 'danger' },
					...gateway,
				};
			}

			return gateway;
		});
		this.nodes = (site.nodes ?? []).map(node => {
			return {
				_cellVariants: {
					// @ts-ignore
					transceiverId: node.transceiverId ? '' : 'danger',
					gatewayId: node.gatewayId ? '' : 'danger',
				},
				...node,
			};
		});

		this.loading = false;
	}

	public created() {
		this.load();

		this.$watch(
			() => this.$route.params.siteId,
			() => {
				this.load();
			},
		);
	}
}
